import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { NEW_SERVICE_TYPE_PATH, SERVICE_TYPE_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import {  SERVICE_TYPE_COLUMN } from "../../../../config/columns";
import { clearServiceTypes, getFilterServiceTypes } from "../../../../actions";

export const ServiceTypes = (
    {
  breadcrumbs,
  serviceTypes,
  loading,
  dispatchGetServiceTypes,
  dispatchClearServiceTypes,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearServiceTypes(), []);

    const data = serviceTypes.get('content') || [];
    const pages = serviceTypes.get('totalPages') || null;
    const defaultPageSize = serviceTypes.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Tipos de Servicio"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_SERVICE_TYPE_PATH}
        tableStructure={{
        columns: SERVICE_TYPE_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetServiceTypes,
        modelPath: SERVICE_TYPE_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetServiceTypes: getFilterServiceTypes,
  dispatchClearServiceTypes: clearServiceTypes,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipo de Servicio',
      href: SERVICE_TYPE_PATH,
    },
  ],
  serviceTypes: BusUnit.ServiceType.getIn(['all', 'content']),
  loading: BusUnit.ServiceType.getIn(['all', 'loading']),
});

ServiceTypes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  serviceTypes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetServiceTypes: PropTypes.func.isRequired,
  dispatchClearServiceTypes: PropTypes.func.isRequired,
};

ServiceTypes.defaultProps = {
  serviceTypes: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTypes);